module.exports = __webpack_public_path__ + "2a25d237c2173ad667d9fd6529988d5a.svg";